/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';

import {
    PanelBody,
    SelectControl,
    ToggleControl,
	TextControl,
    
} from '@wordpress/components';

import {Fragment,useState,useEffect} from '@wordpress/element';

/**
* Internal dependencies
*/
import Select from 'react-select';
import LayoutBuilder from '../sortable-layout.js';
import { VayuBlocksDevice,VayuBlocksDeviceControl } from '@vayu-blocks/device-control';
import {GroupControl, VayuBlocksColorControl,VayuBlocksDimensions, HeightControl,VayuBlocksRangeControl, VayuBlocksBackground, VayuBlocksTypography, VayuBlocksBorder, VayuBlocksAlignment} from '@vayu-blocks';
import { SlideButton } from '@vayu-blocks/global';

const ProductSettingPanel = ({attributes,
            setAttributes,
			openPanels, 
			onTogglePanel}) => { 

	const getView = VayuBlocksDevice();

    const homeUrl = vayublock.homeUrl2;
	
    const [SelectCategories, setSelectCategories] = useState([]);
    const [SelectProduct, setSelectProduct] = useState([]);

    // fetch category
    useEffect(() => {
        // Fetch product categories
        fetch(`${homeUrl}/wp-json/wc/store/v1/products/categories`)
          .then((response) => response.json())
          .then((data) => {
            // Map through the data and convert it to the expected format
            const mappedCategories = data.map((category) => ({
              value: category.id,
              label: category.name,
			  slug: category.slug,
            }));
            setSelectCategories(mappedCategories);
          })
          .catch((error) => {
            console.error('Error fetching categories:', error);
          });
      }, []);

    //fetch product
    useEffect(() => {
      // Fetch product categories
      fetch(`${homeUrl}/wp-json/wc/store/v1/products`)
        .then((response) => response.json())
        .then((data) => {
          // Map through the data and convert it to the expected format
          const mappedProduct = data.map((product) => ({
            value: product.id,
            label: product.name,
          }));
          setSelectProduct(mappedProduct);
        })
        .catch((error) => {
          console.error('Error fetching categories:', error);
        });
    }, []);


    // stock status
    const stockstatus = [
      { value: 'instock', label: 'In Stock' },
      { value: 'outofstock', label: 'Out of Stock' },
      { value: 'onbackorder', label: 'On Backorder' }
    ];
    
const [normalpanel, setnormalpanel] = useState('normal');
	const handelHover = (value) => {
			setnormalpanel(value);
			if (typeof clickBtn === 'function') {
				clickBtn(value);
			}
	}

return (
        <Fragment>
            <PanelBody title={ __( 'General', 'vayu-blocks' ) }
                opened={openPanels['vb-product-general']} onToggle={() => onTogglePanel('vb-product-general')}     
            >
				<ToggleControl
								label={ __( 'Show Tab', 'vayu-blocks' ) }
								checked={ attributes.showTab }
								onChange={ showTab => setAttributes({showTab}) }
							 />
		    {true === attributes.showTab && (
            <Select
            value={attributes.productCategories}
            id="th-cat-select"
            options={SelectCategories}
            isMulti
            isClearable
            maxMenuHeight={300}
            placeholder={__('Choose Category', 'vayu-blocks')}
            onChange={( value ) => {
              setAttributes( { productCategories: ( value ? value : [] ) } );
            }}
            />
		    )}
            <SelectControl
								label={ __( 'Source', 'vayu-blocks' ) }
								value={ attributes.productType }
								options={ [
									{ label:  __( 'Latest Product', 'vayu-blocks' ), value: 'recent' },
									{ label: __( 'Sale', 'vayu-blocks' ), value: 'sale' },
                  { label: __( 'Featured', 'vayu-blocks' ), value: 'featured' },
                  { label: __( 'Manual Product', 'vayu-blocks' ), value: 'manual' },
								] }
								onChange={ e => setAttributes({ productType: e }) }
					  />
            {'manual' === attributes.productType && (
            <Select
            value={attributes.manualProduct}
            id="th-product-select"
            options={SelectProduct}
            isMulti
            isClearable
            maxMenuHeight={300}
            placeholder={__('Choose Product', 'vayu-blocks')}
            onChange={( value ) => {
              setAttributes( { manualProduct: ( value ? value : [] ) } );
            }}
            />
            )}

			<VayuBlocksRangeControl	
					label={<VayuBlocksDeviceControl label={__('Products per page', 'vayu-blocks')} classname='bold' />}
					min={1}
					max={100}
					step={1}
					marks={false}
                    withInputField={true}
					onChange={(key, value) => setAttributes({ [key]: value })}
                    attribute={{key:'productShow', value:attributes.productShow}}
				/>

				<VayuBlocksRangeControl	
					label={<VayuBlocksDeviceControl label={__('Number of column', 'vayu-blocks')} classname='bold' />}
					min={1}
					max={10}
					step={1}
					marks={false}
                    withInputField={true}
					onChange={(key, value) => setAttributes({ [key]: value })}
                    attribute={{key:'productCol', value:attributes.productCol}}
				/>


            <SelectControl
								label={ __( 'OrderBy', 'vayu-blocks' ) }
								value={ attributes.productOrderby }
								options={ [
									{ label:  __( 'Date Product', 'vayu-blocks' ), value: 'date' },
									{ label: __( 'Price', 'vayu-blocks' ), value: 'price' },
                //   { label: __( 'popularity', 'vayu-blocks' ), value: 'popularity' },
                  { label: __( 'Rating', 'vayu-blocks' ), value: 'rating' },
                  { label: __( 'Menu Order', 'vayu-blocks' ), value: 'menu-order' },
								] }
								onChange={ e => setAttributes({ productOrderby: e }) }
					  />

            <SelectControl
								label={ __( 'Order', 'vayu-blocks' ) }
								value={ attributes.productOrder }
								options={ [
									{ label: __( 'DESC', 'vayu-blocks' ), value: 'desc' },
									{ label:  __( 'ASC', 'vayu-blocks' ), value: 'asc' },
									
								] }
								onChange={ e => setAttributes({ productOrder: e }) }
					   />
             <div className='components-base-control'>
            <label>
            { __( 'Exclude Product', 'vayu-blocks' ) }
           </label>
           <Select
            value={attributes.excludeProduct}
            id="th-product-select"
            options={SelectProduct}
            isMulti
            isClearable
            maxMenuHeight={300}
            placeholder={__('Exclude Product', 'vayu-blocks')}
            onChange={( value ) => {
              setAttributes( { excludeProduct: ( value ? value : [] ) } );
            }}
            />
            </div>
            <div className='components-base-control'>
            <label>
            { __( 'Stock Status', 'vayu-blocks' ) }
            </label>
            <Select
              value={stockstatus.filter((option) => attributes.stockStatus.includes(option.value))}
              id="th-stock-status"
              options={stockstatus}
              isMulti
              isClearable
              maxMenuHeight={300}
              placeholder={__('Stock Status', 'vayu-blocks')}
              onChange={(selectedOptions) => {
                const values = selectedOptions ? selectedOptions.map((option) => option.value) : [];
                setAttributes({ stockStatus: values });
              }}
            />
            </div>
			<ToggleControl
								label={ __( 'Show Nav', 'vayu-blocks' ) }
								checked={ attributes.showNavs }
								onChange={ showNavs => setAttributes({showNavs}) }
							 />
            </PanelBody>
			<PanelBody
						title={ __( 'Overlay', 'vayu-blocks' ) }
						opened={openPanels['vb-product-overlay']} onToggle={() => onTogglePanel('vb-product-overlay')} 
						> 

						<SlideButton
							button={{ normal: "Normal", hover: "Hover" }}
							onChange={(value)=>handelHover(value)}
							defaultValue={'normal'}
						/>

						{ 'normal' ===  normalpanel &&  (
						<VayuBlocksColorControl
									onChange={(key, value) => setAttributes({ [key]: value })}
									background={{ value: attributes.overlaybackground, backgroundKey: 'overlaybackground' }}
									/>

						) || 'hover' ===  normalpanel && (
						<>
						<VayuBlocksColorControl
								onChange={(key, value) => setAttributes({ [key]: value })}
								background={{ value: attributes.overlaybackgroundHover, backgroundKey: 'overlaybackgroundHover' }}
						/>
						</>

						)}	
                        
						</PanelBody>
                        <PanelBody
						title={ __( 'Product Elements', 'vayu-blocks' ) }
						opened={openPanels['vb-product-element']} onToggle={() => onTogglePanel('vb-product-element')} 
					    >
						<LayoutBuilder
							attributes={ attributes }
							setAttributes={ setAttributes }
						/>
					 </PanelBody>
                     <PanelBody
						title={ __( 'Product Box', 'vayu-blocks' ) }
						opened={openPanels['vb-product-box']} onToggle={() => onTogglePanel('vb-product-box')} 
					  >
               
					<VayuBlocksAlignment
								label={ __( 'Alignment', 'vayu-blocks' ) }
							    onChange={(key,value)=>setAttributes({[key]:value})}
								alignment = {{key:'productAlign',value:attributes.productAlign}}
					/>

			        <VayuBlocksDimensions  
										onChange={(key,value)=>setAttributes({[key]:value})}
										dimensions={{
												padding: { key: 'productPadding', value: attributes.productPadding }
										}}
									/>
									
			

               <HeightControl
                            label={__('Element Gap', 'vayu-blocks')}
                            value={ attributes.elementGap }
                            onChange={ (value) => setAttributes({elementGap: value }) }
                            responsive={true}
                            customUnits={['px','%','em']}
                            unitMax={{px:{max:100, step:1}}}
                        />

                 <SlideButton
							button={{ normal: "Normal", hover: "Hover" }}
							onChange={(value)=>handelHover(value)}
							defaultValue={'normal'}
						/>

						{ 'normal' ===  normalpanel &&  (
                               <>
                               
								<VayuBlocksBorder 
									onChange={(key,value)=>setAttributes({[key]:value})}
									border={{key:'productboxBorder',value:attributes.productboxBorder}}
									borderRadius={{key:'productboxRadius',value:attributes.productboxRadius}}
									dropShadow = {{key:'productboxShadow',value:attributes.productboxShadow}}
								   />
							</>
						) || 'hover' ===  normalpanel  && (
							<>
							 
							<VayuBlocksBorder 
									onChange={(key,value)=>setAttributes({[key]:value})}
									border={{key:'productboxBorderHover',value:attributes.productboxBorderHover}}
									borderRadius={{key:'productboxRadiusHover',value:attributes.productboxRadiusHover}}
									dropShadow = {{key:'productboxShadowHover',value:attributes.productboxShadowHover}}
								   />
							 </>

						)}

						<VayuBlocksBackground
									onChange={(key,value)=>setAttributes({[key]:value})}
										colorPanel = {[
												{
													active: ['gradient'],
													label: 'Product Box Background',
													key:'productboxClr',
													value:attributes.productboxClr
													
												},
												{
													active: ['gradient'],
													label: 'Hover Product Box Background',
													key:'productboxHvrClr',
													value:attributes.productboxHvrClr
												},
																			
										   ]}
								/>   
					 </PanelBody>
					 <PanelBody
						title={ __( 'Tab Filter', 'vayu-blocks' ) }
						opened={openPanels['vb-product-tab']} onToggle={() => onTogglePanel('vb-product-tab')} 
					  >
						

							 <VayuBlocksAlignment
								label={ __( 'Alignment', 'vayu-blocks' ) }
							    onChange={(key,value)=>setAttributes({[key]:value})}
								alignment = {{key:'tabAlign',value:attributes.tabAlign}}
							/>

						<VayuBlocksTypography
						    value={attributes.tabTypography}
						    onChange={(newValues) => {setAttributes({tabTypography:newValues})}}
					/>

<VayuBlocksBackground
									onChange={(key,value)=>setAttributes({[key]:value})}
										colorPanel = {[
												{
													active: ['color'],
													label: 'Tab Color',
													key:'tabColor',
													value:attributes.tabColor
													
												},
												{
													active: ['color'],
													label: 'Hover Tab Color',
													key:'tabColorHvr',
													value:attributes.tabColorHvr
												},
												{
													active: ['gradient'],
													label: 'Tab Background',
													key:'tabBgColor',
													value:attributes.tabBgColor
													
												},
												{
													active: ['gradient'],
													label: 'Hover Tab Background',
													key:'tabBgColorHvr',
													value:attributes.tabBgColorHvr
												},
																			
										   ]}
								/>   
						
                        <VayuBlocksBorder 
										   onChange={(key,value)=>setAttributes({[key]:value})}
										   border={{key:'tabBorder',value:attributes.tabBorder}}
										   borderRadius={{key:'tabRadius',value:attributes.tabRadius}}
										   dropShadow = {{key:'tabShadow',value:attributes.tabShadow}}
										  />
						 <VayuBlocksDimensions  
										onChange={(key,value)=>setAttributes({[key]:value})}
										dimensions={{
											padding: { key: 'tabPadding', value: attributes.tabPadding },
											margin: { key: 'tabMargin', value: attributes.tabMargin }
										}}
										/>
                </PanelBody>

				<PanelBody
						title={ __( 'Sale', 'vayu-blocks' ) }
						opened={openPanels['vb-product-sale']} onToggle={() => onTogglePanel('vb-product-sale')} 
					  >

				<ToggleControl
									label={ __( 'Sale', 'vayu-blocks' ) }
									checked={ attributes.showSale }
									onChange={ showSale => setAttributes({ showSale }) }
								/>
							  { ( attributes.showSale == true ) && (
                              <>
							  <SelectControl 
								label={ __( 'Sale Style', 'vayu-blocks' ) }
								value={ attributes.saleStyle }
								options={ [
									{ label:  __( 'Classic', 'vayu-blocks' ), value: 'style1' },
									{ label: __( 'Ribbon', 'vayu-blocks' ), value: 'style2' },
									{ label: __( 'Circle', 'vayu-blocks' ), value: 'style3' },
								    
								] }
								onChange={ e => setAttributes({ saleStyle: e }) }
							  />
											<GroupControl
													label={__( 'Position', 'vayu-blocks' )}
													value={ attributes.salePosition }
													onChange={ salePosition => setAttributes({ salePosition }) }
															options={[
													
													{
										
														label: __( 'Right', 'vayu-blocks' ),
														value: 'saleright'
													},
													{
													
														label: __( 'Left', 'vayu-blocks' ),
														value: 'saleleft'
													}
												]}
												
											/>
								
							  
									
									<GroupControl
                                                label={__( 'Design', 'vayu-blocks' )}
												value={ attributes.saleDesign }
												onChange={ saleDesign => setAttributes({ saleDesign }) }
												options={[
													{
													
														label: __( 'Text', 'vayu-blocks' ),
														value: 'saletext'
													},
													{
										
														label: __( 'Digit', 'vayu-blocks' ),
														value: 'saledigit'
													}
												]}
												
											/>
							
                                { ( attributes.saleDesign == 'saletext' ) && (
								<TextControl
									label={ __( 'Sale Text', 'vayu-blocks' ) }
									value={ attributes.saleText }
									onChange={ ( saleText ) => setAttributes({saleText}) }
							    />
								)}

                                <VayuBlocksBackground
									onChange={(key,value)=>setAttributes({[key]:value})}
										colorPanel = {[
																			{
																				active: ['color'],
																				label: 'Sale Color',
																				key:'saleClr',
																				value:attributes.saleClr
													
																			},
																			{
																				active: ['gradient'],
																				label: 'Sale Background',
																				key:'saleBgClr',
																				value:attributes.saleBgClr
																			},
																			
																		]}
								                                    />

			<HeightControl
										label={__('Border Radius', 'vayu-blocks')}
										value={ attributes.saleBrdradius }
										onChange={ (value) => setAttributes({saleBrdradius: value }) }
										responsive={true}
										customUnits={['px','%','em']}
										unitMax={{px:{max:100, step:1}}}
									/>

								</>


							  )}

				</PanelBody>

				<PanelBody
						title={ __( 'Wishlist & Compare', 'vayu-blocks' ) }
						opened={openPanels['vb-product-meta']} onToggle={() => onTogglePanel('vb-product-meta')} 
					  >
				<ToggleControl
												label={ __( 'Wishlist', 'vayu-blocks' ) }
												checked={ attributes.showWishlist }
												onChange={ showWishlist => setAttributes({showWishlist}) }
											/>
											<ToggleControl
												label={ __( 'Compare', 'vayu-blocks' ) }
												checked={ attributes.showCompare }
												onChange={ showCompare => setAttributes({ showCompare }) }
											/>
					<VayuBlocksBackground
									onChange={(key,value)=>setAttributes({[key]:value})}
										colorPanel = {[
																			{
																				active: ['color'],
																				label: 'Post Meta Color',
																				key:'postMetaClr',
																				value:attributes.postMetaClr
																			},
																			{
																				active: ['color'],
																				label: 'Hover Post Meta Color',
																				key:'postMetaHvrClr',
																				value:attributes.postMetaHvrClr 
													
																			},
																			{
																				active: ['gradient'],
																				label: 'Post Meta Background',
																				key:'postMetaBgClr',
																				value:attributes.postMetaBgClr 
																			},
																			{
																				active: ['gradient'],
																				label: 'Hover Post Meta Background',
																				key:'postMetaBgHvrClr',
																				value:attributes.postMetaBgHvrClr 
																			},
																			
																		]}
								/>
				</PanelBody>

        </Fragment>
        );
}
export default ProductSettingPanel;